// ** React Imports
import { useState, useEffect, useRef } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField'
import {
    Typography,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent
} from '@mui/material'
import { useNavigate } from "react-router-dom";
// import Icon from '../../../icon';

export default function Index() {
    const navigate = useNavigate();

    // ** State
    const [openStep, setOpenStep] = useState<1 | 2 | null>(null);
    const [nik, setNik] = useState("");
    const [wo, setWo] = useState("");
    const [mode, setMode] = useState("");

    const nikRef = useRef<HTMLInputElement>(null);
    const woRef = useRef<HTMLInputElement>(null);

    const handleOpen = (mode: any) => {
        setMode(mode)
        setOpenStep(1);
    }

    const handleSubmit = (e?: React.FormEvent) => {
        e?.preventDefault();

        if (openStep === 1 && nik.trim() !== "") {
            setOpenStep(2);
        } else if (openStep === 2 && wo.trim() !== "") {
            localStorage.setItem("NIK", nik);
            localStorage.setItem("WO", wo);

            setOpenStep(null);
            navigate("/mm/penggunaan-barang/daftar-proses");
        }
    };

    const handleClose = () => setOpenStep(null);

    useEffect(() => {
        if (openStep === 1 && nikRef.current) {
            nikRef.current.focus();
        }
        if (openStep === 2 && woRef.current) {
            woRef.current.focus();
        }
    }, [openStep]);

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12} sm={12}>
                <Typography variant='h4' sx={{ textAlign: 'center' }}>
                    Bon Barang
                </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }} onClick={() => navigate('/mm/penggunaan-barang/joblist')}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={'/icons/joblist.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Joblist</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onClick={() => handleOpen('add')}
                        >
                            <img src={'/icons/add.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Permintaan Baru</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onClick={() => handleOpen('edit')}
                        >
                            <img src={'/icons/edit.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Edit Permintaan</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        // onClick={() => handleOpen('batal')}
                        >
                            <img src={'/icons/delete.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Batal Permintaan</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={'/icons/print.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Cetak Ulang Nota Usage</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={6} sm={4}>
                <div className={'content-block dx-card'} style={{ borderRadius: 10 }}>
                    <CardContent>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <img src={'/icons/print.png'} alt='Add' width={140} loading='lazy' />
                            <Typography variant='h5'>Cetak Ulang Label Asset</Typography>
                        </Box>
                    </CardContent>
                </div>
            </Grid>

            {/* Dialog Step 1: Input NIK */}
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openStep === 1}
                onClose={handleClose}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit}>
                    <DialogTitle sx={{ color: '#212121' }}>Masukkan NIK</DialogTitle>
                    <DialogContent sx={{ color: '#212121' }}>
                        <TextField
                            inputRef={nikRef}
                            margin="dense"
                            label="NIK"
                            type="text"
                            fullWidth
                            value={nik}
                            onChange={(e) => setNik(e.target.value)}
                            required
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Batal</Button>
                        <Button type="submit" disabled={!nik.trim()}>
                            Lanjut
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {/* Dialog Step 2: Input WO */}
            {/* <Dialog open={openStep === 2} onClose={handleClose}> */}
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openStep === 2}
                onClose={handleClose}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit}>
                    <DialogTitle sx={{ color: '#212121' }}>Masukkan WO</DialogTitle>
                    <DialogContent sx={{ color: '#212121' }}>
                        <TextField
                            inputRef={woRef}
                            margin="dense"
                            label="WO"
                            type="text"
                            fullWidth
                            value={wo}
                            onChange={(e) => setWo(e.target.value)}
                            required
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Batal</Button>
                        <Button type="submit" disabled={!wo.trim()}>
                            Simpan
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
